import styled from '@emotion/styled';

const Spinner = styled.div`
  height: 100px;
  position: relative;
  width: 100px;
`;

const SpinnerLoader = styled.div`
  animation: rotation 0.7s infinite linear;
  background-color: transparent;
  border-bottom: 5px solid #cbcbca;
  border-left: 5px solid #cbcbca;
  border-radius: 100%;
  border-right: 5px solid #cbcbca;
  border-top: 5px solid #2380be;
  height: 100px;
  left: 50%;
  margin: 0 0 0 -50px;
  position: absolute;
  top: 0;
  width: 100px;
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(359deg);
    }
  }
`;

const SpinnerOverlay = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  margin: 0 auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 20;
  @supports (backdrop-filter: blur()) {
    /* For browsers that support it, use a frosted glass effect */
    .SpinnerOverlay {
      backdrop-filter: blur(3px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
`;

const ExitSpinnerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 174px;
  position: relative;
  width: 100%;
`;

const ExitSpinnerTexts = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 100px;
`;

const ExitSpinnerText = styled.span`
  font-size: 28px;
  margin-top: 1rem;
`;

const ExitSpinnerSubText = styled.span<{ text?: boolean }>`
  font-size: 18px;
  max-width: 320px;
  text-align: center;
  margin-top: ${props => (props.text ? '0.625rem' : '1rem')};
  line-height: 24px;
`;

const SpinnerContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100px;
  justify-content: center;
  left: 50%;
  margin: 0 0 0 -50px;
  position: absolute;
  top: 0;
  width: 100px;
`;

export {
  Spinner,
  ExitSpinnerContainer,
  ExitSpinnerTexts,
  SpinnerLoader,
  SpinnerOverlay,
  ExitSpinnerText,
  ExitSpinnerSubText,
  SpinnerContainer,
};
